import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { format } from '@breezeway/brzw-react-core';

const DateAndTimeCell = props => (
  <div className="rt-td--default">
    <span>
      {_.has(props.value, 'date')
        ? format.datetime.formatDateAndTime(props.value.date, props.value.time)
        : null}
    </span>
  </div>
);

DateAndTimeCell.propTypes = {
  value: PropTypes.shape({
    date: PropTypes.string,
    time: PropTypes.string,
  }),
};

export default DateAndTimeCell;
